import repository from '@/repositories/repository'
import url from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/waba-template`

    return {
        index(queryParams = {}) {
            return repository.get(`${baseUrl}?${url.serialize(queryParams)}`)
        },
        showByName(name) {
            return repository.get(`${baseUrl}/name/${encodeURIComponent(name)}`)
        },
        syncFromEngine(name) {
            return repository.post(`${baseUrl}/sync`, {name})
        },
        datatable(queryParams = {}) {
            return repository.get(`${baseUrl}/datatable?${url.serialize(queryParams)}`)
        },
    }
}
